import api from './client';
import { API_ENDPOINTS } from './endpoints';

export type EmailBuilderBlockType = 'header' | 'text' | 'image' | 'button' | 'table' | 'divider';

export interface EmailBuilderBlockStyle {
  color?: string;
  backgroundColor?: string;
  fontSize?: number;
  align?: 'left' | 'center' | 'right';
  padding?: number;
  bold?: boolean;
}

export interface EmailBuilderBlock {
  id: string;
  type: EmailBuilderBlockType;
  text?: string;
  href?: string;
  src?: string;
  alt?: string;
  widthPercent?: number;
  tableRows?: string[][];
  style: EmailBuilderBlockStyle;
}

export interface EmailTemplateApiItem {
  _id: string;
  event_key: string;
  name: string;
  description?: string;
  subject: string;
  body_html: string;
  available_variables?: string[];
  is_active: boolean;
  is_custom?: boolean;
  builder_blocks?: EmailBuilderBlock[] | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface EmailTemplatesListResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    templates?: EmailTemplateApiItem[];
  };
}

export interface EmailTemplateMutationResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: EmailTemplateApiItem;
}

export interface EmailTemplateDeleteResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: unknown;
}

export interface UpdateEmailTemplatePayload {
  name?: string;
  description?: string;
  subject?: string;
  body_html?: string;
  is_active?: boolean;
  available_variables?: string[];
  builder_blocks?: EmailBuilderBlock[] | null;
}

export interface CreateEmailTemplatePayload {
  name: string;
  description?: string;
  subject: string;
  body_html: string;
  is_active?: boolean;
  available_variables?: string[];
  builder_blocks?: EmailBuilderBlock[] | null;
}

export const getEmailTemplates = async (): Promise<EmailTemplatesListResponse> => {
  return api.get<EmailTemplatesListResponse>(API_ENDPOINTS.emailTemplates.list);
};

export const createEmailTemplate = async (
  payload: CreateEmailTemplatePayload,
): Promise<EmailTemplateMutationResponse> => {
  return api.post<EmailTemplateMutationResponse, CreateEmailTemplatePayload>(
    API_ENDPOINTS.emailTemplates.list,
    payload,
  );
};

export const updateEmailTemplate = async (
  id: string,
  payload: UpdateEmailTemplatePayload,
): Promise<EmailTemplateMutationResponse> => {
  return api.put<EmailTemplateMutationResponse, UpdateEmailTemplatePayload>(
    `${API_ENDPOINTS.emailTemplates.list}/${id}`,
    payload,
  );
};

export const deleteEmailTemplate = async (id: string): Promise<EmailTemplateDeleteResponse> => {
  return api.delete<EmailTemplateDeleteResponse>(`${API_ENDPOINTS.emailTemplates.list}/${id}`);
};
